module.exports = __webpack_public_path__ + "static/media/grand-pere-jean-sponsor.d44d82d1.png";